// eslint-disable-next-line import/prefer-default-export
export var MODIFIERS = {
  TODAY: "today",
  SELECTED: "selected",
  DISABLED: "disabled",
  OUTSIDE: "outside",
  HIGHLIGHTED: "highlighted",
  IN_RANGE: "in-range",
  RANGE_START: "range-start",
  RANGE_END: "range-end"
};